import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { TextField } from '@mui/material';
import { api } from 'src/Api';

export default function FrequencyDropDown({ setFunction, width, error, dontAppend }) {
  const [frequency, setFrequency] = useState([]);

  function getFrequency() {
    const requestOptions = {
      method: 'POST',
      redirect: 'follow'
    };
    console.log('fetching');
    fetch(api.getofferfrequency, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success == true) {
          dontAppend
            ? setFrequency(result.data)
            : setFrequency([{ id: 0, name: 'All' }, ...result.data]);
        }
      })
      .catch((error) => console.log('error', error));
  }

  const handleChange = (event) => {
    setFunction(event.target.value);
  };

  useEffect(() => {
    getFrequency();
  }, []);
  return (
    <TextField
      error={error}
      color={error ? 'error' : 'primary'}
      fullWidth
      style={{ width: width }}
      select
      label={'Frequency'}
      onChange={handleChange}
    >
      {frequency.map((option) => (
        <MenuItem key={option.id} value={option}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
